import React from 'react';
import ThreeMonthPlanEmpty from './ThreeMonthPlanEmpty';
import ThreeMonthPlanFilled from './ThreeMonthPlanFilled';

interface ThreeMonthPlanProps {
  studentUuid: string;
  studentName: string;
  teacherName?: string;
  isSentToStudent?: boolean;
}

const ThreeMonthPlan: React.FC<ThreeMonthPlanProps> = ({
  studentUuid,
  studentName,
  teacherName,
  isSentToStudent
}) => {
  if (!isSentToStudent) {
    return <ThreeMonthPlanEmpty studentName={studentName} teacherName={teacherName} />;
  }

  return <ThreeMonthPlanFilled studentUuid={studentUuid} studentName={studentName} />;
};

export default ThreeMonthPlan;
